import { render, staticRenderFns } from "./UpgradeModal.vue?vue&type=template&id=4fa8676b&scoped=true&"
import script from "./UpgradeModal.vue?vue&type=script&lang=ts&"
export * from "./UpgradeModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpgradeModal.vue?vue&type=style&index=0&id=4fa8676b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa8676b",
  null
  
)

export default component.exports